import React, { useState } from "react";
import { Card, CardBody, Row, Col, Label, Input, Button } from "reactstrap";

export default function Comments({ value, onChange }) {

    const handleChange = (e) => {
        const { name, value: newValue } = e.target;
        onChange({
            ...value,
            [name]: newValue
        });
    };

    const handleClear = () => {
        onChange({ purchaseNotes: "", internalNotes: "" });
    };

    return (
        <Card>
            <CardBody>
                <Row className="g-4">
                    <Col lg={12}>
                        <Label className="form-label">
                            Purchase Notes: <small className="text-muted">(Visible to Vendor)</small>
                        </Label>
                        <Input
                            type="textarea"
                            name="purchaseNotes"
                            value={value.purchaseNotes}
                            onChange={handleChange}
                            rows="5"
                        />
                    </Col>

                    <Col lg={12}>
                        <Label className="form-label mt-3">
                            Internal Notes: <small className="text-muted">(Not Visible to Vendor)</small>
                        </Label>
                        <Input
                            type="textarea"
                            name="internalNotes"
                            value={value.internalNotes}
                            onChange={handleChange}
                            rows="5"
                        />
                    </Col>

                    <Col lg={12} className="d-flex justify-content-end mt-4">
                        <Button color="secondary" outline onClick={handleClear}>
                            Clear Notes
                        </Button>
                    </Col>
                </Row>
            </CardBody>
        </Card>
    );
}

